import { ColumnsType } from "antd/es/table";
import { useIntl } from "react-intl";
import { useMemo } from "react";
import { Ticket } from "@ticketingplatform/api/dist/ticket/fragments/__generated__/Ticket";
import environment from "setup/environment";

import { UseTicketColumnsProps } from "./types";

export const useTicketColumns = <TTicket extends Ticket = Ticket>({
  additionalColumns = [],
}: UseTicketColumnsProps<TTicket>): ColumnsType<TTicket> => {
  const intl = useIntl();

  return useMemo<ColumnsType<TTicket>>(
    () => [
      {
        key: "ticketNumber",
        dataIndex: "ticketNumber",
        title: intl.formatMessage({ defaultMessage: "Ticket ID" }),
      },
      {
        key: "name",
        dataIndex: "name",
        title: intl.formatMessage({ defaultMessage: "Ticket" }),
      },
      {
        key: "price",
        dataIndex: "price",
        title: intl.formatMessage({ defaultMessage: "Ticket Price" }),
        render: (
          _,
          { price, venueFeeSubtotalAmount, platformFeeSubtotalAmount }
        ) =>
          intl.formatNumber(
            price + venueFeeSubtotalAmount + platformFeeSubtotalAmount,
            {
              style: "currency",
              currency: environment.CURRENCY,
            }
          ),
      },
      {
        key: "discountAmount",
        dataIndex: "discountAmount",
        title: intl.formatMessage({ defaultMessage: "Discount" }),
        render: (discountAmount) =>
          intl.formatNumber(-discountAmount, {
            style: "currency",
            currency: environment.CURRENCY,
          }),
      },
      {
        key: "status",
        dataIndex: "status",
        title: intl.formatMessage({ defaultMessage: "Status" }),
      },
      ...additionalColumns,
    ],
    [intl, additionalColumns]
  );
};
